export enum FormSection {
  Referral = 'referral',
  Withdrawal = 'withdrawal',
  WithdrawalPhone = 'withdrawalPhone',
  Placement = 'placement',
  PlacementOutreachDays = 'placementOutreachDays',
  RevocationConsentElapsed = 'revocationConsentElapsed',
  IneligibilityLetterPwnRecommendation = 'ineligibilityLetterPwnRecommendation',
  DeclassificationProjectedDeclassification = 'declassificationProjectedDeclassification',
  DischargeDateDischargeReason = 'dischargeDateDischargeReason',
}

export enum FormControls {
  Referral = 'referral',
  Withdrawal = 'withdrawal',
  Phone = 'phone',
  Placement = 'placement',
  OutreachDays = 'outreachDays',
  RevocationConsent = 'revocationConsent',
  Elapsed = 'elapsed',
  IneligibilityLetter = 'ineligibilityLetter',
  PwnRecommendation = 'pwnRecommendation',
  DeclassificationDocument = 'declassificationDocument',
  ProjectedDate = 'projectedDate',
  DeclassificationParent = 'declassificationParent',
  DischargeReason = 'dischargeReason',
  DischargeDate = 'dischargeDate',
  DischargeReasons = 'dischargeReasons',
}
